import React, { Component } from "react";
import axios from "axios";
// import HeaderDashboard from "../../part/header.dashaboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import FooterDashboard from "../../part/footer.dashboard";
// import { FiEyeOff } from "react-icons/fi";
// import { FiEye } from "react-icons/fi";
import Image from "../../image/icons.png"
import { TbCameraPlus } from "react-icons/tb";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";



class TutorProfile extends Component {
  state = {
    menuCoverWidth: this.getInitialMenuCoverWidth(),
    windowHeight: window.innerHeight - 60,
    isActive: false,
    // passwordVisible: false,
    // password: '',
    profile_image: null,
    selectedImage: null,
    firstname: '',
    lastname: '',
    // middlename: '',
    // phone: '',
    // address: '',
    email: '',
    // nation: '',
    // gender: '',
    // DOB: '',
    // affiliation: '',
    // advertise: '',
    // otherOption: '',
    originalData: null,
    // Track if any changes have been made
    hasChanges: false,
    isContactVisible: false,
    error: ''
  }
  fileInputRef = React.createRef();
  getInitialMenuCoverWidth() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 900) {
      return 0;
    } else if (windowWidth >= 900 && windowWidth < 1200) {
      return 60;
    } else {
      return 260;
    }
  }



  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.fetchCourses();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  fetchCourses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/profile/", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const profileData = response.data;
      this.setState({ 
        courses: profileData,
        firstname: profileData.first_name || "",
        lastname: profileData.last_name || "",
        // middlename: profileData.middle_name || "",
        // phone: profileData.phone_number || "",
        // address: profileData.address || "",
        email: profileData.email || "",
        // nation: profileData.nation || "",
        // gender: profileData.gender || "",
        // DOB: profileData.DOB || "",
        // affiliation: profileData.affiliation || "",
        // advertise: profileData.source || "",  // Assuming 'source' maps to 'advertise'
        profile_image: profileData.profile_picture  ? `https://api.geoinfoacademy.com${profileData.profile_picture}` : null, // Handle image URL
        selectedImage: profileData.profile_picture  ? `https://api.geoinfoacademy.com${profileData.profile_picture}` : null, // Handle image URL
        originalData: profileData, // Store the original data
        hasChanges: false, // Initially, no changes
      
      });
      console.log("API Response:", response.data);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        window.location.href = "/"; 
      } else {
        console.error("Error fetching data:", error);
      }
    }
  };



  handleResize = () => {
    const menuCover = document.querySelector('.dashboard .menu_cover');
    if (menuCover) {
      this.setState({ menuCoverWidth: menuCover.offsetWidth });
    }
    this.setState({ windowHeight: window.innerHeight - 60 });
  };


  // this is the handle of the input and submit

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value, hasChanges: true })
  }

  handleSubmit = async (event) => {
    
   
    event.preventDefault();
    const formData = new FormData();
    formData.append('first_name', this.state.firstname);
    formData.append('last_name', this.state.lastname);
    // formData.append('middle_name', this.state.middlename);
    // formData.append('phone_number', this.state.phone);
    // formData.append('address', this.state.address);
    // formData.append('nation', this.state.nation);
    // formData.append('gender', this.state.gender);
    formData.append('email', this.state.email);
    // formData.append('DOB', this.state.DOB);
    // formData.append('password', this.state.password);
  //   formData.append('affiliation', this.state.affiliation);
  //   if (this.state.advertise === "Others") {
  //     formData.append('source', this.state.otherOption);
  // } else {
  //     formData.append('source', this.state.advertise);
  // }
    

  if (this.state.profile_image instanceof File) {  // Key change: Check if it's a File object
    formData.append('profile_picture', this.state.profile_image);
    console.log("check image", this.state.profile_image);
} else if (this.state.hasChanges && !this.state.profile_image && this.state.originalData && this.state.originalData.profile_picture) {
  //If there are changes, no new image, but an old image exists, send the old image. This handles deleting images
    formData.append('profile_picture', null);
    console.log("Deleting Image")
}
else {
    console.log("No new image selected, using existing or no image.");
    // If no new image and no changes to other fields, you might not even need to make the API call
    if (!this.state.hasChanges) {
      console.log("No changes to profile. Skipping update.");
      return; // or display a message: alert("No changes to save.")
    }
}



    try {
      const accessToken = localStorage.getItem('accessToken');
      const response = await axios.patch('https://api.geoinfoacademy.com/api/tutor/profile/', formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      console.log('API response:', response);
      this.setState({
        hasChanges: false,
        originalData: { ...this.state.courses, ...this.state }, // Update original data
        error: 'Changes Updated'
      });
      setTimeout(() => {
        this.setState({ error: '' });
    }, 5000);
      this.fetchCourses();
    } catch (error) {
      console.error('Error submitting form:', error);
      this.setState({ error: "Error Occured" });
      setTimeout(() => {
          this.setState({ error: '' });
      }, 5000);

    }
  };








  // for the password visibility 

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      passwordVisible: !prevState.passwordVisible,
    }));
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };






  // selected image handle
  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({ profile_image: event.target.files[0] });
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();

      reader.onload = (e) => {
        this.setState({ selectedImage: e.target.result });
      };
      reader.readAsDataURL(file);
    }

  };

  handleDragOver = (event) => {
    event.preventDefault();
  };

  handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    this.handleFileChange({ target: { files: [file] } });
  };
 
  handleButtonClick = (e) => {
    e.preventDefault()
    this.fileInputRef.current.click();
  };

  render() {
    const { menuCoverWidth } = this.state;
    const {
      // passwordVisible, password,
      selectedImage } = this.state;
    return (
      <div className="dashboard">
        <DashSearchHeader onResize={this.handleResize} />
        <TutorDashMenu />
        <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)` }} >
          <div className="profile_body tutor">
            <form onSubmit={this.handleSubmit}>
              <h2>
                <span>My Profile</span>
                <button className="save" type="submit">Update Profile</button>
              </h2>
              <p className={this.state.error}>{this.state.error}</p>
              <div className="profile_info one">
                <section className="profile_pic"><section className="image_cover" onDragOver={this.handleDragOver} onDrop={this.handleDrop}>{selectedImage ? (<img src={selectedImage} alt="profile_picture" />) : (
                  <img src={Image} alt="profile_picture" />)}<button onClick={this.handleButtonClick}><TbCameraPlus /></button>
                  <input type="file" id='thumb' accept="image/*" onChange={this.handleFileChange} ref={this.fileInputRef} style={{ display: 'none' }}
                  /></section></section>
                <div className="profile_name"><label htmlFor="firstname">First Name</label><br /><input placeholder="First Name" name="firstname" id="firstname" value={this.state.firstname} onChange={this.handleInputChange} /><br /><br /></div>
                <div className="profile_name"><label htmlFor="lastname">Last Name</label><br /><input placeholder="Last Name" name="lastname" id="lastname" value={this.state.lastname} onChange={this.handleInputChange} /><br /><br /></div>
                {/* <label htmlFor="middlename">Middle Name</label><br /><input placeholder="Middle Name" name="middlename" id="middlename" value={this.state.middlename} onChange={this.handleInputChange} /><br /><br /> */}
                {/* <label htmlFor="password">Password </label><br /><input placeholder="Password" type={passwordVisible ? 'text' : 'password'} id="password" value={password} onChange={this.handlePasswordChange} />
              {passwordVisible ? (<FiEye onClick={this.togglePasswordVisibility} className="password" />) : (<FiEyeOff onClick={this.togglePasswordVisibility} className="password" />)}<br /><br /> */}
                <label htmlFor="email">Email</label><br /><input placeholder="@gmail.com" autoComplete="email" name="email" id="email" value={this.state.email} onChange={this.handleInputChange} /><br /><br />
                {/* <label htmlFor="phone">Phone</label><br /><input placeholder="0900000000" autoComplete="phone" type="number" min="0" name="phone" id="phone" value={this.state.phone} onChange={this.handleInputChange} /><br /><br />
                <label htmlFor="address">Address</label><br /><input placeholder="No 9 unknown street" name="address" id="address" value={this.state.address} onChange={this.handleInputChange} /><br /><br /> */}

              </div>
              {/* <div className="profile_info two">
                <label htmlFor="gender">Gender</label><br /><select name="gender" id="gender" value={this.state.gender} onChange={this.handleInputChange}><option value="">Select Gender</option><option value='Male'>Male</option><option value='Female'>Female</option></select><br /><br />
              <label htmlFor="nation">Nation</label><br /><select name="nation" id="nation" value={this.state.nation} onChange={this.handleInputChange}><option>Select Country</option></select><br /><br />
              <label htmlFor="DOB">Date of Birth</label><br /><input type="date" name="DOB" id="DOB" value={this.state.DOB} onChange={this.handleInputChange} /><br /><br />
                <select name="affiliation" id='affiliation' value={this.state.affiliation} onChange={this.handleInputChange}>
                  <option value="">Select Affiliation</option>
                  <option value="Student">Student</option>
                  <option value="Private Sector">Private Sector</option>
                  <option value="Public Sector">Public Sector (Government)</option>
                </select><br /><br />
                <label htmlFor="advertise">How did you get this information</label><br />
                <select name="advertise" id='advertise' value={this.state.advertise} onChange={this.handleInputChange}>
                  <option value="">Select</option>
                  <option value="Friends">Friends</option>
                  <option value="Families">Families</option>
                  <option value="WhatsApp">WhatsApp</option>
                  <option value="T.V/Radio">T.V/Radio</option>
                  <option value="School">School</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Google">Google</option>
                  <option value="Others">Others</option>
                </select><br /><br />
                {this.state.advertise === 'Others' && (
                  <div><input
                    type="text"
                    placeholder="Enter other option"
                    name="otherOption"
                    id="otherOption"
                    value={this.state.otherOption}
                    onChange={this.handleInputChange}
                  /><br /><br /></div>
                )}
              </div> */}
              <div className="submit">
                <button className="save" type="submit">Update Profile</button>
              </div>
            </form>
          </div>
          <FooterDashboard  />
          <Policy />
        </div>
      </div>
    )
  }
}


export default TutorProfile